import NoDataFoundImage from "../../../assets/images/empty_item.svg";
import "./noDataFound.scss";
const NoDataFound = () => {
  return (
    <>
      <div className="table-wrap position-relative page-no-data">
        <div className="no-data-found">
          <div className="text-center">
            <img alt="" src={NoDataFoundImage} width={110} className="mb-3 mx-auto" />
            <h3 className="text-secondary font-12">No Record Found</h3>
          </div>
        </div>
      </div>
    </>
  );
};
export default NoDataFound;
